var exports = {
  "Pf": "MyProfileTabUsernameSection.module__label___VGRCdm",
  "o1": "MyProfileTabUsernameSection.module__actions___VGRCdm",
  "Sn": "MyProfileTabUsernameSection.module__premiumButton___VGRCdm",
};

module.exports = exports;
